export const CART_ADD="CART_ADD"
export const CART_REMOVE='CART_REMOVE'
export const CART_QUANTITY='CART_QUANTITY'
export const CART_EMPTY='CART_EMPTY'